import { UUID } from '../../../../types/shared/UUID';
import { PolicyTypeEnum } from '../../../../policyUI/classes/PolicyTypeEnum';
import React from 'react';
import { clientUrls } from '../../../../ui-toolkit/rest/ClientUrlFactory';
import { FlexRow, NavigationItem } from '../../../../ui-toolkit';
import { UploadPolicyContainer } from '../../../../pages/order/title/uploadPolicies/UploadPolicyContainer';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../../API/documentCategories/DocumentCategoriesApi';
import { useParams } from 'react-router-dom';

interface IGenericCreateProps {
  policyType: PolicyTypeEnum;
  isAmericanDigital: boolean;
}

const text = {
  [PolicyTypeEnum.owner]: "Create Owner's Policy",
  [PolicyTypeEnum.shortForm]: "Create Short Form Lender's Policy",
  [PolicyTypeEnum.longForm]: "Create Long Form Lender's Policy",
};

export const GenericCreatePolicy: React.FC<IGenericCreateProps> = ({ policyType, isAmericanDigital }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: { allCategories } = defaultNormalizedDocumentCategoriesData } = useListDocumentCategoriesQuery();

  return (
    <>
      <FlexRow>
        <NavigationItem
          appearance={'primary'}
          intent={'primary'}
          text={text[policyType]}
          to={clientUrls.urlFor.policyGeneration(orderId, policyType, 'create')}
        />
      </FlexRow>
      {isAmericanDigital || (
        <UploadPolicyContainer orderId={orderId} documentCategories={allCategories} policyUploadType={policyType} />
      )}
    </>
  );
};
